const API_KEY = 'AIzaSyCs5_RmGk3nZ3vhnO5i--WyvCBBpHGnmSU';
const SESSION_KEY = 'mukwei-admin-session';

const readSession = () => {
  try {
    return JSON.parse(window.localStorage.getItem(SESSION_KEY)) || null;
  } catch (error) {
    return null;
  }
};

const writeSession = (session) => {
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const signInAdmin = async (email, password) => {
  const response = await fetch(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${encodeURIComponent(API_KEY)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, returnSecureToken: true }),
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error('The email or password is incorrect.');
  const session = {
    idToken: result.idToken,
    refreshToken: result.refreshToken,
    email: result.email,
    expiresAt: Date.now() + Number(result.expiresIn || 3600) * 1000,
  };
  writeSession(session);
  return session;
};

const refreshedSession = async (session) => {
  const response = await fetch(
    `https://securetoken.googleapis.com/v1/token?key=${encodeURIComponent(API_KEY)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: session.refreshToken,
      }),
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error('Your session has expired. Please sign in again.');
  const updated = {
    ...session,
    idToken: result.id_token,
    refreshToken: result.refresh_token,
    expiresAt: Date.now() + Number(result.expires_in || 3600) * 1000,
  };
  writeSession(updated);
  return updated;
};

export const currentAdminSession = () => readSession();
export const signOutAdmin = () => window.localStorage.removeItem(SESSION_KEY);

export const adminRequest = async (path, options = {}) => {
  let session = readSession();
  if (!session) throw new Error('Please sign in.');
  if (session.expiresAt - Date.now() < 60000) session = await refreshedSession(session);

  const response = await fetch(`/api/admin/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.idToken}`,
      ...(options.headers || {}),
    },
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'The operation could not be completed.');
  return result;
};
